<template>
    <div>
        <div class="hint mb-6 md:mb-8">
          You have to fill your address data for us to be able to process your fund
        </div>
        <speakol-select
          class="mb-6 md:mb-8"
          label="Country "
          placeholder="Country"
          v-model="country"
          validation="required"
          :options="countryOptions"
          ref="country"
        />
        <speakol-input
          label="City"
          placeholder="City"
          class="mb-6 md:mb-8"
          v-model="city"
          validation="required"
          ref="city"
        />
        <speakol-input
          label="Street"
          placeholder="Street"
          class="mb-6 md:mb-8"
          v-model="street"
          validation="required"
          ref="street"
        />
    </div>
</template>


<script>

import { objectToFormData } from '@/helpers/objectToFormData.js'

export default {
  data () {
    return {
      countryOptions: [],
      country: null,
      city: null,
      street: null
    }
  },

  methods: {

    async getCountry () {
      const response = await window.axios.get('/countries')
      return (response.data || []).map((countryObject) => {
        return {
          text: countryObject.name,
          value: countryObject.id
        }
      })

    },

    async submit () {
      const isInputsValid = await this.validateInputs()
      if (isInputsValid) {
        return await this.updateAccount()
      }

    },

    async validateInputs () {
      const isCountryValid = await this.$refs['country'].validate()
      const isCityValid = await this.$refs['city'].validate()
      const isStreetValid = await this.$refs['street'].validate()
      return isCountryValid && isCityValid && isStreetValid
    },

    async updateAccount () {
      const accountId = localStorage.getItem('activeAccountId')
      const body = {
        account: {
          country_id: this.country.value,
          address: {
            city: this.city,
            street: this.street
          }
        }
      }
      const response = await this.$store.dispatch('accounts/updateAccount', {
        accountId,
        body: objectToFormData(body)
      })
      if (response && response.data) {
        const source = response.data
        this.$store.commit('authentication/UPDATE_ACTIVE_ACCOUNT', source)
        this.$store.commit('authentication/UPDATE_ACCOUNTS', source)
        // this line to fetch the account data to update the status banner
        this.$store.dispatch('authentication/getUserAuth', localStorage.getItem('activeAccountId'))
        this.$emit('account-updated', response.data)
      }

    }


  },

  async mounted () {
    this.countryOptions = await this.getCountry()
  }

}
</script>

<style lang="scss">
    .hint {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 21px;
      color: rgba(0, 0, 0, 0.56);
    }
</style>
